import { React, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { MainHeader } from '.';
import { useTree } from '../../../Context/useTree';
import getSingleItems from '../../../Api/getSingleItems'
import getRecommendedItems from '../../../Api/getRecommendedItems';
import { cacheAPIResponse, getCachedResponse } from '../../../Helpers/SessionStorage';
import { Link, useLocation } from 'react-router-dom';

let MenuItem = () => {
  let { item, location, menuId, submenuId } = useParams();
  let path = useLocation();
  const { fetchTree, findItemById } = useTree();
  console.log(item)
  const [menuItem, setMenuItem] = useState([]);
  const [recommendedItems, setrecommendedItems] = useState([]);


  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });  
  }, [path.pathname]);

  useEffect(() => {
    fetchTree(location)
      .then(() => {
        // Try to find item from tree first
        const treeItem = findItemById(item);
        if (treeItem) {
          setMenuItem(treeItem);
        } else {
          // Fallback to API if not in tree
          const itemCacheKey = `singleItem-${item}`;
          const cachedItem = getCachedResponse(itemCacheKey);
          
          if (cachedItem) {
            setMenuItem(cachedItem);
          } else {
            getSingleItems(item)
              .then(response => {
                response.json().then(data => ({
                  data: data,
                  status: response.status
                }))
                  .then(jsonResponse => {
                    setMenuItem(jsonResponse.data);
                    cacheAPIResponse(itemCacheKey, jsonResponse.data);
                    console.log(jsonResponse)
                  })
              })
              .catch((error) => {
                console.log(error);
              })
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching tree:", error);
      });

    // Cache key for recommended items
    const recommendedCacheKey = `recommendedItems-${location}-${item}`;
    const cachedRecommended = getCachedResponse(recommendedCacheKey);
    
    if (cachedRecommended) {
      setrecommendedItems(cachedRecommended);
    } else {
      getRecommendedItems(location, item)
        .then(response => {
          response.json().then(data => ({
            data: data,
            status: response.status
          }))
            .then(jsonResponse => {
              setrecommendedItems(jsonResponse.data);
              cacheAPIResponse(recommendedCacheKey, jsonResponse.data);
              console.log(jsonResponse.data)
            })
        })
        .catch((error) => {
          console.log(error);
        })
    }

  }, [location, item, submenuId, fetchTree, findItemById]);

  const displayImage = () => {
    // Check tree properties: itemImageUrl or itemImagePath, then fallback to old API properties
    let imageUrl = menuItem.itemImageUrl || menuItem.itemImagePath || menuItem.imagePath;
    
    if (!imageUrl) {
      // No image - show text
      const name = menuItem.itemName || menuItem.displayName || "Item";
      const description = menuItem.description || "";
      return (
        <>
          <p className="single-item-title">{name}</p>
          {description && <p className="single-item-description">{description}</p>}
        </>
      );
    } else {
      // Has image
      return <img src={imageUrl} className="responsive-image" alt={menuItem.itemName || "Item"} />;
    }
  }
  const displayRecommendedItems = () => {
    //need to do a check on if the images returned have no images to remove the recommended items
    var filterdRecommendations = recommendedItems.filter(item =>{

      if (item.HasImage === "Y")
        return item;
      else 
        return false;
    })


    if (filterdRecommendations.length ===0)
      return <></>

    // Build the correct link based on whether submenuId exists
    const baseLink = submenuId 
      ? `/v2/${location}/${menuId}/${submenuId}/items/` 
      : `/v2/${location}/${menuId}/items/`;

    return (
     <div className="menu-background-section">
      <p className="single-item-title">Try one of our other favorites!</p>
        <div className="suggestion-images" >
          {filterdRecommendations.map(items => {
            return (
            <Link key={items.MenuItemID} to={`${baseLink}${items.MenuItemID}`}>
                  <img src={items.imagePath} alt={`image of ${items.MenuItemID}`} className="responsive-image" /> 
            </Link>
          )
          })}
        </div>
      </div>
    
    )
  }


  return (
    <>
      <MainHeader />
      <section className="body single-item-page">

        <>
          <div >
            <div className="menu-background-section">
              {/* <h2>Selected Item</h2> */}
              {displayImage()}
            </div>
            {displayRecommendedItems()}
          </div>
        </>
      </section>
    </>
  );
}

export default MenuItem;